export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#ffffff' }} className="border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 lg:grid-cols-3 gap-10">
        {/* Brand & Contact */}
        <div className="lg:col-span-1">
          <img
            src="https://lirp.cdn-website.com/035eb9cd/dms3rep/multi/opt/The+Oaks+Manor-1920w.png"
            alt="The Oaks Manor"
            className="h-14 w-auto object-contain mb-5"
          />
          <p className="text-navy/70 text-sm leading-relaxed mb-5">
            Compassionate in-home senior care in Oakland, IL — helping your loved ones live safely, comfortably, and independently.
          </p>
          <ul className="space-y-3 text-sm text-navy">
            <li className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-phone-fill text-gold"></i>
              </span>
              <span>
                <a href="tel:(217) 346-2042" className="hover:text-gold transition-colors font-semibold">(217) 346-2042</a>
                <span className="text-navy/50 mx-2">|</span>
                <a href="tel:(941) 799-1552" className="hover:text-gold transition-colors">(941) 799-1552</a>
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-mail-line text-gold"></i>
              </span>
              <a href="mailto:eric@alhusa.com" className="hover:text-gold transition-colors">eric@alhusa.com</a>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-map-pin-line text-gold"></i>
              </span>
              <a
                href="https://maps.app.goo.gl/PREvdTkT8jNmMXEJ6"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="hover:text-gold transition-colors"
              >
                111 South Walnut, Oakland, IL 61943
              </a>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-time-line text-gold"></i>
              </span>
              <span className="text-navy/70">Mon – Sun: 8:00 am – 6:00 pm<br /><span className="text-gold font-medium">24/7 community care available</span></span>
            </li>
          </ul>
          <a
            href="https://facebook.com/TheOaksManor/#"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 mt-5 text-navy hover:text-gold transition-colors"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-navy/10 rounded-full">
              <i className="ri-facebook-fill text-base"></i>
            </span>
            <span className="text-sm font-medium">Follow Us on Facebook</span>
          </a>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-heading text-navy font-semibold text-lg mb-5">
            <a href="/services/personal-care" id="footer-services-link">Our Services</a>
          </h4>
          <ul className="space-y-3 text-sm">
            {[
              { label: 'Personal Care', href: '/services/personal-care' },
              { label: 'Companion Care', href: '/services/companion-care' },
              { label: "Alzheimer's & Dementia Care", href: '/services/alzheimers-dementia-care' },
              { label: 'Respite Care', href: '/services/respite-care' },
              { label: 'Post-Hospital Recovery', href: '/services/post-hospital-recovery' },
            ].map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="text-navy/70 hover:text-gold transition-colors flex items-center gap-2"
                >
                  <i className="ri-arrow-right-s-line text-gold text-base"></i>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          <h4 className="font-heading text-navy font-semibold text-lg mt-8 mb-5">Company</h4>
          <ul className="space-y-3 text-sm">
            {[
              { label: 'About Us', href: '/about' },
              { label: 'Oakland, IL Senior Care', href: '/locations/oakland-il' },
              { label: 'Contact Us', href: '/contact' },
            ].map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="text-navy/70 hover:text-gold transition-colors flex items-center gap-2"
                >
                  <i className="ri-arrow-right-s-line text-gold text-base"></i>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Map */}
        <div>
          <h4 className="font-heading text-navy font-semibold text-lg mb-5">
            <a href="/locations/oakland-il" id="footer-location-link">Find Us</a>
          </h4>
          <div className="rounded-xl overflow-hidden h-52 w-full">
            <iframe
              title="Oak Senior Care Location Map"
              src="https://maps.google.com/maps?q=111+South+Walnut,+Oakland,+IL+61943&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
            />
          </div>
          <div className="mt-4 p-4 rounded-xl" style={{ backgroundColor: '#F3F4F5' }}>
            <p className="text-navy text-xs font-semibold uppercase tracking-widest mb-1">Service Area</p>
            <p className="text-navy/70 text-sm">Oakland, IL & surrounding communities including Camargo, Newman, Hindsboro, and Coles County.</p>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{ backgroundColor: '#F3F4F5' }}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-navy/60 text-xs">&copy; 2026 The Oaks Manor. All rights reserved.</p>
          <div className="flex items-center gap-4 text-xs text-navy/60">
            <a href="/terms-and-conditions" className="hover:text-gold transition-colors">Terms &amp; Conditions</a>
            <span>|</span>
            <a href="/privacy-policy" className="hover:text-gold transition-colors">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
